import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OverlayService } from './overlay.service';

@Injectable()
export class MaintenanceService {
	showMaintenance = false;

	constructor(private router: Router, private overlay: OverlayService) {}

	serverMaintenance(message) {
		if (message == 'Server Maintenance') {
			this.overlay.updateOverlay(false);
			this.redirectToMaintenancePage();
		}
	}

	redirectToMaintenancePage() {
		this.setMaintenancePage(true);
		this.overlay.updateOverlay(false);
		this.overlay.updateRefresh(false);
		this.router.navigate(['/maintenance']);
	}

	setMaintenancePage(show) {
		if (show) {
			this.showMaintenance = true;
		} else {
			this.showMaintenance = false;
		}
	}

	inMaintenance() {
		return this.showMaintenance;
	}
}
